import classNames from "classnames";
import React, { useMemo } from "react";
import { Image as ImageComp } from "./../../ui-components";
import { RICOS_DEFAULTS } from "../consts";
import ExpandIcon from "../icons/expand";
import styles from "../statics/styles/image-viewer.rtlignore-scss";
import { ImageContainer } from "./image-container";
import { useCustomWidthStyle } from "./use-custom-width-style";
import { useFallbackWidthStyle } from "./use-fallback-width-style";
import { useImageDimensions } from "./use-image-dimensions";
import { useImageSocialAttributes } from "./use-image-social-attributes";
const Image = ({
  dataUrl,
  node,
  className,
  config,
  helpers,
  isMobile,
  seoMode,
  imageClickActionConfig,
  expand,
  shouldLazyLoadImages
}) => {
  const containerData = node.imageData?.containerData || RICOS_DEFAULTS.containerData;
  const { image, altText } = node.imageData || {};
  const { src } = image || {};
  const disableDownload = node.imageData?.disableDownload === true ? (e) => e.preventDefault() : void 0;
  const imageSource = useMemo(() => {
    if (dataUrl) {
      return dataUrl;
    }
    const { url, id } = src || {};
    if (url) {
      return url;
    }
    const { getImageUrl } = helpers ?? {};
    if (getImageUrl && id) {
      return getImageUrl({ file_name: id });
    }
    return id;
  }, [
    dataUrl,
    node.imageData?.image?.src?.url,
    node.imageData?.image?.src?.id,
    helpers?.getImageUrl
  ]);
  const { width, height } = useImageDimensions({
    src: imageSource,
    containerData,
    image
  });
  const fallbackWidthStyle = useFallbackWidthStyle({ containerData, isMobile });
  const customWidthStyle = useCustomWidthStyle({ containerData, isMobile, width });
  const socialAttributes = useImageSocialAttributes({
    config,
    src,
    width: image?.width,
    height: image?.height
  });
  const doDimensionsExist = width !== void 0 && height !== void 0;
  return /* @__PURE__ */ React.createElement(ImageContainer, { ...imageClickActionConfig, disableDownload }, doDimensionsExist && imageSource && /* @__PURE__ */ React.createElement(
    ImageComp,
    {
      id: node.imageData?.image?.src?.id ?? imageSource,
      containerId: node.id,
      displayMode: "fill",
      width,
      height,
      uri: node.imageData?.image?.src?.id ?? imageSource,
      alt: altText || "",
      containerProps: {
        className: classNames(styles.imageWrapper, styles.imageRatio, className, {
          [styles.pointer]: !!expand
        }),
        containerId: node.id,
        style: {
          ["--dim-height"]: height,
          ["--dim-width"]: width,
          ...fallbackWidthStyle,
          ...customWidthStyle
        }
      },
      imageStyles: {
        maxWidth: "100%"
      },
      socialAttrs: { ...socialAttributes, draggable: false },
      isSEOBot: !!seoMode,
      ...shouldLazyLoadImages ? {
        placeholderTransition: seoMode ? void 0 : "blur",
        shouldUseLQIP: config?.disableTransition !== false
      } : {}
    }
  ), !!expand && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: styles.expandContainer,
      onClick: expand,
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          expand(e);
        }
      },
      role: "button",
      tabIndex: 0
    },
    /* @__PURE__ */ React.createElement(ExpandIcon, { className: styles.expandIcon })
  ));
};
export {
  Image
};
//# sourceMappingURL=image.js.map
